import page from "router/page";
import _ from "lodash";

import Report from "report/report";

/**
 * Handle the display of performance/estimatesvsactuals report
 */
class EstimatesVsActualsReport extends Report {

    name = 'estimatesvsactuals';
    title = 'Performance: Estimates vs Actuals';

    /**
     * Define the routes being handle by performance/estimatesvsactuals
     */
    registerRoutes() {
        let app = this.app;

        page('/performance/estimatesvsactuals', (context) => {
            this.setReport(context);
            this.assemble();
        });
    }

    /**
     * Do post UI handling after loading the data
     */
    assemble() {
        let app             = this.app;
        let projectSelector = app.findComponent('ProjectSelector');
        let project         = app.get('active.project');

        projectSelector.apply();

        if (project) { projectSelector.o.setValue(project.ProjectID); }

        if (!app.hasRecords()) { return; }
    }
}

module.exports = EstimatesVsActualsReport;